
import React from "react";

export const Header = (props) => {
  return (
    <header id="header" style={{ overflowX: "hidden" }}>
      <div className="intro">
        <div
          className="overlay"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            width: "100%",
            margin: 0,
            padding: 0,
          }}
        >
          <div className="container">
            <div className="row">
              <div
                className="col-md-8 col-md-offset-2 intro-text"
                style={{
                  textAlign: "center",
                }}
              >
                <h1>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <h3 style={{ color: "white" }}>
                  {props.data ? props.data.description : "Loading"}
                </h3>
                <p>{props.data ? props.data.paragraph : "Loading"}</p>
                <a
                  style={{
                    backgroundColor: "red",
                    color: "white",
                    borderRadius: "5px",
                  }}
                  href="#features"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
